import React from 'react';
import styled from 'styled-components';
import Scroll from '../../assets/Scroll';
import useColorfulBalls from '../../hooks/useColorfulBalls';
import { Logo, ColContainer } from '../atoms';
import Keynote from '../atoms/Keynote';

import * as RScroll from 'react-scroll';

const scroll = RScroll.animateScroll;

const Wrapper = styled(ColContainer)`
  position: fixed;
  z-index: 3;
  top: 0;
  right: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  backdrop-filter: blur(6px);
`;

const MainWrapper = styled(ColContainer)`
  position: relative;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: 600px;
`;

const PresentedByWrapper = styled.div`
  position: absolute;
  left: 40px;
  top: 56px;
`;

const CenterWrapper = styled(ColContainer)`
  padding: 0 40px;
  width: 100%;
  align-items: flex-start;
`;

const MainTitle = styled.div`
  font-weight: 900;
  font-size: 40px;
  letter-spacing: -0.02em;
`;

const SubTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  color: #eaeaea;
`;

const ScrollWrapper = styled.div`
  //position: fixed;
  bottom: 24px;
  width: 20vw;
  max-width: 100px;
  min-width: 77px;
  cursor: pointer;
`;

const TouchArea = styled.div`
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: center;
  padding: 32px 0px 24px 0px;
  width: 100vw;
`;

function Title() {
  useColorfulBalls();

  return (
    <Wrapper>
      <MainWrapper>
        <PresentedByWrapper>
          <Logo w='32px' h='32px' />
          Presented by
          <br />
          <b>YOURSSU</b>
        </PresentedByWrapper>
        <CenterWrapper>
          <MainTitle>Road to Pro</MainTitle>
          <SubTitle>구르다 보면 보이는 것들</SubTitle>
        </CenterWrapper>

        <Keynote />

        <TouchArea
          onClick={() => {
            scroll.scrollTo(window.visualViewport.height);
          }}
        >
          <ScrollWrapper>
            <Scroll width='100%' />
          </ScrollWrapper>
        </TouchArea>
      </MainWrapper>
    </Wrapper>
  );
}

export default Title;
